import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import NavigationService from '@/Management/NavigationService';

export default class HotkeyBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.hotkey = {
            init: (node: HTMLElement, valueAccessor: () => { shortcut: string | Array<string>, handler: Function, suspendOnModal: boolean, isGlobal: boolean }) => {
                let value = valueAccessor();
                let shortcut = value.shortcut || null;
                let handler = value.handler || null;
                let isGlobal = value.isGlobal !== false;
                let element = $(node);

                // Sorgt daf�r, das die Hotkeys genutzt werden k�nnen, obwohl ein Control fokussiert ist
                // Siehe: https://craig.is/killing/mice#api.stopCallback
                Mousetrap.prototype.stopCallback = (e, element, combo) => {
                    let control = element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA';
                    let callbackedKeys = ['alt+s', 'command+s', 'backspace', 'space'];

                    if ((callbackedKeys.some(x => x === combo) && control) || callbackedKeys.some(x => x === combo)) {
                        return false;
                    }

                    return control;
                }


                if (shortcut == null || handler == null) {
                    return;
                }

                if (typeof shortcut == "string") {
                    shortcut = [shortcut];
                }

                let mousetrap = isGlobal ? Mousetrap : Mousetrap(node);

                let isolatedViewFactoryCount = NavigationService.getInstance().getModalViewFactories();

                mousetrap.bind(shortcut, (e: ExtendedKeyboardEvent) => {
                    if (value.suspendOnModal !== true || isolatedViewFactoryCount == NavigationService.getInstance().getModalViewFactories()) {
                        var ret = handler(e);
                    }
                    if (ret === false || ret === true) {
                        return ret;
                    }
                    return false;
                });

                ko.utils.domNodeDisposal.addDisposeCallback(node, () => {
                    if (mousetrap != null) {
                        mousetrap.unbind(shortcut);
                        mousetrap = null;
                    }
                });
            }
        };
    }

    public static addHotkey(node: HTMLElement, shortcut: string, handler: Function): void {
        ko.applyBindingsToNode(node, {
            hotkey: {
                shortcut: shortcut,
                handler: handler,
                isGlobal: false
            }
        });
    };
}